module.exports = __webpack_public_path__ + "static/media/EquinixConnectivityStudio_PartnerFAQ_v1.5.31e7b594.pdf";